// extracted by mini-css-extract-plugin
export default {"container":"LessonDescription_container__TLfC-","description":"LessonDescription_description__uPkOo","h3":"LessonDescription_h3__qHweN","date":"LessonDescription_date__lcZbz"};